export default "__VITE_ASSET__Prsx5dP___"